var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 14.7483C15.5734 14.7483 18.1668 15.2477 18.1668 17.1743C18.1668 19.1017 15.5564 19.5834 12.5002 19.5834C9.42768 19.5834 6.8335 19.084 6.8335 17.1573C6.8335 15.23 9.44397 14.7483 12.5002 14.7483ZM12.5002 5.41675C14.582 5.41675 16.2501 7.08418 16.2501 9.16458C16.2501 11.245 14.582 12.9131 12.5002 12.9131C10.419 12.9131 8.75026 11.245 8.75026 9.16458C8.75026 7.08418 10.419 5.41675 12.5002 5.41675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilledIcon);
export default __webpack_public_path__ + "static/media/user-filled-icon.1e6e1ed421bfd94debcf5dc1b5eef696.svg";
export { ForwardRef as ReactComponent };